<template>
  <v-slide-group class="bg-background">
    <v-slide-group-item v-for="(trip, index) in unsavedTrips" :key="index">
      <div style="max-width: 300px" class="pa-2 mt-2 rounded-lg bg-background">
        <UnsavedTripCard :trip="trip" />
      </div>
    </v-slide-group-item>
  </v-slide-group>
</template>

<script setup lang="ts">
import { useTripStore, type Trip } from "@/domains/trips";
import { computed } from "vue";
import UnsavedTripCard from "./UnsavedTripCard.vue";

const tripStore = useTripStore();

const unsavedTrips = computed<Trip[]>(() => tripStore.getUnsavedTrips);
</script>
